import { useCookieDeclaration } from '$/hooks/useCookieDeclaration';

export const CookieDeclaration = () => {
  useCookieDeclaration();

  return null;
};
